const calculateOneTimeImplementationCost = (initiative) => {
  let totalCost = 0; // Initialize totalCost here

  // Ensure initiative and its properties exist before accessing them
  if (!initiative || (!initiative.KPI && !initiative.impact)) {
    return 0;
  }

  // Calculate cost from KPI
  if (initiative.KPI && Array.isArray(initiative.KPI)) {
    initiative.KPI.forEach((kpi) => {
      // Changed 'impact' to 'kpi' for clarity when iterating KPI array
      if (kpi.UniversalKPI && kpi.UniversalKPI.startsWith('One Time Implementation')) {
        // Ensure annuallyPlan exists and is an array before reducing
        if (kpi.annuallyPlan && Array.isArray(kpi.annuallyPlan)) {
          const amount = kpi.annuallyPlan.reduce((sum, val) => sum + (val || 0), 0);
          if (kpi.UniversalKPI.includes('Cost for')) {
            totalCost += amount; // Add to totalCost
          }
        }
      }
    });
  }

  // Calculate cost from impact
  if (initiative.impact && Array.isArray(initiative.impact)) {
    initiative.impact.forEach((impact) => {
      // Corrected the typo in the string: 'One implementation Cost (ETB)'
      if (impact.frequencyAndDirection === 'One implementation Cost (ETB)') {
        // Ensure annuallyPlan exists and is an array before reducing
        if (impact.annuallyPlan && Array.isArray(impact.annuallyPlan)) {
          const amount = impact.annuallyPlan.reduce((sum, val) => sum + (val || 0), 0);
          totalCost += amount; // Add to totalCost
        }
      }
    });
  }

  return totalCost; // Return the final calculated totalCost
};

export default calculateOneTimeImplementationCost;
